export function TickInCircle() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="12" fill="currentColor"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M18.1535 7.88424C18.5857 8.33701 18.569 9.0544 18.1162 9.48659L10.7829 16.4866C10.562 16.6974 10.2654 16.8102 9.96023 16.7994C9.65507 16.7886 9.36717 16.6551 9.16177 16.4291L5.82843 12.7625C5.40739 12.2993 5.44152 11.5826 5.90467 11.1615C6.36782 10.7405 7.08459 10.7746 7.50563 11.2378L10.0578 14.0452L16.5512 7.84698C17.0039 7.4148 17.7213 7.43148 18.1535 7.88424Z"/>
    </svg>
  );
}